// General

export const LOT_TO_UNIT = 100;

// Form Options
//

export const FORM_OPTIONS = {
  DISABLED_FORMS: {
    DT_BUY_LIMIT: 'DT_BUY_LIMIT',
    DT_SELL_LIMIT: 'DT_SELL_LIMIT',
    MT_BUY_LIMIT: 'MT_BUY_LIMIT',
    MT_SELL_LIMIT: 'MT_SELL_LIMIT',
    MT_BUY_AUTO: 'MT_BUY_AUTO',
    MT_SELL_AUTO: 'MT_SELL_AUTO',
  },
  ORDER_SIDE: ['BUY', 'SELL'],
  ACCOUNT_TYPE: [
    { value: 'REGULAR', label: 'Reguler', orderTypes: ['LIMIT', 'AUTO'] },
    { value: 'DAY_TRADING', label: 'Day Trading', orderTypes: ['LIMIT'] },
    { value: 'MARGIN_TRADING', label: 'Margin', orderTypes: ['LIMIT'] },
  ],
  ORDER_TYPE: [
    { key: 'LIMIT', name: 'Limit' },
    { key: 'AUTO', name: 'Auto' },
  ],
  ORDER_PERIOD: [
    { value: 'DAY', label: 'Hari' },
    { value: 'SESSION', label: 'Sesi' },
  ],
  BTN_PERCENTAGE: [
    { value: 0.25, label: '25%' },
    { value: 0.5, label: '50%' },
    { value: 0.75, label: '75%' },
    { value: 1, label: '100%' },
  ],
  AUTO_THRESHOLD_COMPARATOR: [
    { value: 'LTE', label: '≤' },
    { value: 'GTE', label: '≥' },
  ],
};

// FormState keys
//

export const formKey = {
  // Form Config
  /**
   * value: Array of key-value objects
   * - [key]: DT_BUY_LIMIT | DT_SELL_LIMIT | MT_BUY_LIMIT | MT_SELL_LIMIT | MT_BUY_AUTO | MT_SELL_AUTO
   * - [value]: callback function
   * */
  CONST_DISABLED_FORMS: 'CONST_DISABLED_FORMS',
  /** value: CREATE | AMEND */
  CONST_FORM_TYPE: 'CONST_FORM_TYPE',

  // General Order Details
  /** value: BUY | SELL */
  INPUT_ORDER_SIDE: 'INPUT_ORDER_SIDE',
  /** value: REGULAR | DAY_TRADING | MARGIN_TRADING */
  INPUT_ACCOUNT_TYPE: 'INPUT_ACCOUNT_TYPE',
  /** value: LIMIT | AUTO */
  TAB_ORDER_TYPE: 'TAB_ORDER_TYPE',
  /** value: DAY | SESSION */
  INPUT_ORDER_PERIOD: 'INPUT_ORDER_PERIOD',

  // Limit Order Details
  INPUT_PRICE: 'INPUT_PRICE',
  INPUT_LOT_COUNT: 'INPUT_LOT_COUNT',
  BTN_PERCENTAGE: 'BTN_PERCENTAGE',
  CALC_ORDER_TOTAL: 'CALC_ORDER_TOTAL',

  // Auto Order Details
  INPUT_START_DATE: 'INPUT_START_DATE',
  INPUT_END_DATE: 'INPUT_END_DATE',
  INPUT_THRESHOLD_COMPARATOR: 'INPUT_THRESHOLD_COMPARATOR',
  INPUT_THRESHOLD_VALUE: 'INPUT_THRESHOLD_VALUE',

  // Amend Details
  CONST_ORDER_ID: 'CONST_ORDER_ID',
  CONST_IDX_ORDER_ID: 'CONST_IDX_ORDER_ID',
  CONST_STATUS: 'CONST_STATUS',

  // API Data
  CONST_DEFAULT_PRICE: 'CONST_DEFAULT_PRICE',
  CONST_MAX_BUY: 'CONST_MAX_BUY',
  CONST_MAX_BUY_LABEL: 'CONST_MAX_BUY_LABEL',
  CONST_MAX_BUY_DT: 'CONST_MAX_BUY_DT',
  CONST_MAX_BUY_LABEL_DT: 'CONST_MAX_BUY_LABEL_DT',
  CONST_MAX_BUY_MT: 'CONST_MAX_BUY_MT',
  CONST_MAX_BUY_LABEL_MT: 'CONST_MAX_BUY_LABEL_MT',
  CONST_MAX_SELL: 'CONST_MAX_SELL',
  CONST_MAX_SELL_DT: 'CONST_MAX_SELL_DT',
  CONST_MAX_SELL_MT: 'CONST_MAX_SELL_MT',
  CONST_MAX_LOT_AMEND: 'CONST_MAX_LOT_AMEND',
};
